import React, { useCallback } from 'react';
import { Modal, Empty, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash.get'
import { Link } from 'react-router-dom';
import { NotificationGroups } from '@/constants/record-types';
import { setFilter, clearFilter } from '@/pages/shared/shared.reducer';

const NO_NOTIFICATIONS = [];

const Notifications = (props) => {
    const dispatch = useDispatch();
    const notifications = useSelector(({ userDetails }) => get(userDetails, 'notifications.notifications') || NO_NOTIFICATIONS);
    const userId = useSelector(({ userDetails }) => get(userDetails, 'info.id'));
    const userName = useSelector(({ userDetails }) => get(userDetails, 'info.username'));

    const setFilterForTable = useCallback((notification) => {
        dispatch(clearFilter(notification.tableId));

        notification.filter.forEach(item => {
            dispatch(setFilter(notification.tableId, item.key, item.value));
        });
    }, [dispatch]);

    const notificationList = NotificationGroups(userId, userName);

    const notificationItems = notifications && notifications.length > 0 
        ? notifications.map((item, index) => {
            const notificationDefinition = notificationList.find(notify => notify.id == item.notificationsGroupId);

            return (
                <div key={index}>
                    <div className="row">
                        <div className="col-1">
                            <i style={{ fontSize: "18px" }} className="pe-3 ri-notification-3-line" />
                        </div>
                        <div className="col-11 mt-1">
                            <b>{notificationDefinition?.title || 'Notification'}</b>
                            <div className="mt-2 text-secondary">{item.notificationText}</div>
                            {notificationDefinition && <div className="display-center">
                                <Link to={notificationDefinition.link + '?clear=false'}
                                    onClick={() => { setFilterForTable(notificationDefinition) }} >
                                    Go to section
                                </Link>
                                <i className="ps-2 pt-1 ri-arrow-right-s-line" style={{ fontSize: "12px" }} />
                            </div>}
                        </div>
                    </div>
                    {index != notifications.length - 1 && <hr style={{ borderTop: "dashed 1px", color: 'lightgrey' }} />}
                </div>);
        })
        : null;

    return (
        <Modal
            className="notification"
            placement="top"
            closable={false}
            footer={null}
            onCancel={props.onClose}
            open={props.visible}
        >
            <div style={{height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                <Button className="display-center custom-close-modal" onClick={() => props.onClose()}>
                    <i className="ri-close-line"></i>Close
                </Button>
                <h1 className="mb-5 mt-4">Notifications</h1>
                {notificationItems && notificationItems.length > 0 ? notificationItems : <Empty description="Empty List of Notifications" />}
            </div>
        </Modal>
    );
}

export default Notifications;
